import { Injector } from "@angular/core";
import {
    AppSettingsBurgerMenuExtension,
    AppSettingsHeaderExtension,
    AppSettingsNavigationCategoryExtension,
    AppSettingsNavigationItemExtension,
    ExtensionRegistry,
    FeedbackExtension,
    FooterLinkExtension,
    FullScreenExtension,
    GbBurgerHandbookMenuExtension,
    HandbookHeaderExtension,
    HeaderPanelExtension,
    HomeHeaderLoginExtension,
    MoreNavigationActionExtension,
    MoreNavigationDialogExtension,
    MoreNavigationLinkExtension,
    TermsOfUseLinkExtension,
} from "@geolib/geoappbase-client";
import { HandbookBackToAppExtension } from "./handbook/handbook-back-to-app.extension";
import { HandbookMenuExtension } from "./handbook/handbook-menu.extension";
import { GeobusHeaderInfoExtension } from "./headerInfo/geobus-header-info.extension";
import GeobusTermsOfUseExtension from "./home/geobus-footer-term-of-use.extension";
import { GeobusStartPageExtension } from "./home/geobus-start-page.extension";
import FooterHelpExtension from "./home/start-page-footer-help.extension";
import GeobusCommunityExtension from "./menu/geobus-community.extension";
import GeobusDataExtension from "./menu/geobus-data.extension";
import GeobusFTPServerExtension from "./menu/geobus-ftp-server.extension";
import GeobusGeneralExtension from "./menu/geobus-general.extension";
import GeobusModelExtension from "./menu/geobus-model.extension";
import GeobusOrganisationExtension from "./menu/geobus-organisation.extension";
import GeobusToDoExtension from "./menu/geobus-todo.extension";
import GeobusTopicExtension from "./menu/geobus-topic.extension";
import GeobusTrackingExtension from "./menu/geobus-tracking.extension";
import GeobusUserAdministrationExtension from "./menu/geobus-user-admin.extension";
import GeobusUserOrganisationExtension from "./menu/geobus-user-organisation.extension";
import GeobusFooterLinkImpressumExtension from "./moreNavigation/GeobusFooterLinkImpressumExtension";
import { GeobusAboutExtension } from "./moreNavigation/GeobusAboutExtension";
import GeobusCourseProgramLinkExtension from "./moreNavigation/GeobusCourseProgramLinkExtension";
import GeobusImpressumLinkExtension from "./moreNavigation/GeobusImpressumLinkExtension";
import EventSubscriptionExtension from "./user/event-subscription.extension";
import UserProfileExtension from "./user/user-profile.extension";


// eslint-disable-next-line max-statements
export const registerExtensions = (extensionRegistry: ExtensionRegistry, injector: Injector): void => {

    extensionRegistry.registerExtensionInterface(HomeHeaderLoginExtension);
    extensionRegistry.register(injector.get(GeobusStartPageExtension));

    extensionRegistry.registerExtensionInterface(FooterLinkExtension);
    extensionRegistry.register(injector.get(FooterHelpExtension));
    extensionRegistry.register(injector.get(GeobusTermsOfUseExtension));
    extensionRegistry.register(injector.get(GeobusFooterLinkImpressumExtension));

    extensionRegistry.registerExtensionInterface(MoreNavigationDialogExtension);
    extensionRegistry.register(injector.get(GeobusAboutExtension));
    extensionRegistry.register(injector.get(FeedbackExtension));

    extensionRegistry.registerExtensionInterface(MoreNavigationActionExtension);
    extensionRegistry.register(injector.get(UserProfileExtension));
    extensionRegistry.register(injector.get(EventSubscriptionExtension));
    extensionRegistry.register(injector.get(FullScreenExtension));
    extensionRegistry.register(injector.get(HandbookMenuExtension));

    extensionRegistry.registerExtensionInterface(MoreNavigationLinkExtension);
    extensionRegistry.register(injector.get(GeobusCourseProgramLinkExtension));
    extensionRegistry.register(injector.get(TermsOfUseLinkExtension));
    extensionRegistry.register(injector.get(GeobusImpressumLinkExtension));

    extensionRegistry.registerExtensionInterface(HeaderPanelExtension);
    extensionRegistry.register(injector.get(GeobusHeaderInfoExtension));

    extensionRegistry.registerExtensionInterface(HandbookHeaderExtension);
    extensionRegistry.register(injector.get(HandbookBackToAppExtension));
    extensionRegistry.register(injector.get(GbBurgerHandbookMenuExtension));

    extensionRegistry.registerExtensionInterface(AppSettingsHeaderExtension);
    extensionRegistry.register(injector.get(AppSettingsBurgerMenuExtension));

    extensionRegistry.registerExtensionInterface(AppSettingsNavigationCategoryExtension);
    extensionRegistry.register(injector.get(GeobusGeneralExtension));
    extensionRegistry.register(injector.get(GeobusUserOrganisationExtension));
    extensionRegistry.register(injector.get(GeobusDataExtension));

    extensionRegistry.registerExtensionInterface(AppSettingsNavigationItemExtension);
    extensionRegistry.register(injector.get(GeobusToDoExtension));
    extensionRegistry.register(injector.get(GeobusTrackingExtension));
    extensionRegistry.register(injector.get(GeobusUserAdministrationExtension));
    extensionRegistry.register(injector.get(GeobusOrganisationExtension));
    extensionRegistry.register(injector.get(GeobusTopicExtension));
    extensionRegistry.register(injector.get(GeobusModelExtension));
    extensionRegistry.register(injector.get(GeobusCommunityExtension));
    extensionRegistry.register(injector.get(GeobusFTPServerExtension));
};
